import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import { useGetVirtualBankAccounts } from 'api';

import type { VirtualAccount } from 'models/virtualAccount';

import { useOrganisationId } from 'hooks/context';

type VirtualAccountsContextProps = {
  accounts: VirtualAccount[];
  isFetching: boolean;
  isSuccess: boolean;
  isLoading: boolean;
};

const VirtualAccountsContext = createContext({} as VirtualAccountsContextProps);

type Props = {
  children: ReactNode;
};

export const VirtualAccountsProvider = ({ children }: Props) => {
  const organisationId = useOrganisationId<number>();

  const {
    data: { data: accounts } = { data: [] },
    isFetching,
    isSuccess,
    isLoading
  } = useGetVirtualBankAccounts(organisationId);

  return (
    <VirtualAccountsContext.Provider
      value={{
        accounts: accounts as VirtualAccount[],
        isFetching,
        isSuccess,
        isLoading
      }}
    >
      {children}
    </VirtualAccountsContext.Provider>
  );
};

export const useVirtualAccountsContext = () =>
  useContext(VirtualAccountsContext);
